
# This class presents a simple marker toolbar on the map
class L.Control.MfMarker extends L.Control.MfButtonGrid
    constructor: () ->
        super()
        @setDefaults()

    setColor: (color) =>
        @color = color
    # set default options.
    setDefaults: () =>
        @options =
            position: 'topleft'
            draw:
                style:
                    color: '#008161'
                    width: 3
            finished:
                style:
                    'fillOpacity': 0.6,
                    'weight': 2,
                    'color': '#0F0'
            colors:
                style: (mode) =>
                    return {
                        color: '#008000'
                        width: 3
                    }
            toolbars: [
                {
                    style: {
                        width: '30x'
                        height: '30px'
                    }
                    rows: [
                        [
                            { name: 'draw-marker', html: '<i class="fas fa-pencil-alt"></i>', toggle: true }
                        ]
                    ]
                }
            ]

    setStealthStyling: () =>
        @options =
            position: 'topleft'
            draw:
                style:
                    color: '#008161'
                    width: 3
            finished:
                style:
                    'fillOpacity': 0.6,
                    'weight': 2,
                    'color': '#0F0'
            colors:
                style: (mode) =>
                    return {
                        color: '#008000'
                        width: 3
                    }
            toolbars: [
                {
                    rows: []
                }
            ]

    # When the control is added to the map, register the callback and init the marker tool
    onAdd: (map) ->
        @map ?= map
        @mode = null
        @current_tool = null
        container = super(map)

        # @addCallback '*', @anyButtonPressed
        @addCallback 'draw-marker', @drawMarker

        @map.on 'draw:created', @handleMarkerDrop

        @selectBtn 'draw-marker'
        @drawMarker()

        return container


    handleMarkerDrop: (e) =>
        # console.log(e)
        @enableBtn 'draw-marker'
        @deselectBtn 'draw-marker'
        @fire('mfmarker:dropped', e)


    # Handle initializing the marker tool
    drawMarker: () =>
        @disableBtn 'draw-marker'
        @current_tool = new L.Draw.Marker(@map,  {
            icon: new L.mapbox.marker.icon({
                # 'marker-size': 'large',
                'marker-color': @color,
                'marker-symbol': 'circle',
            }),
            draggable: true
        })

        @current_tool.enable()
        @fire('mfmarker:tool_selected')

    deselect: () =>
        @current_tool.disable()


    select: () =>
        @current_tool.enable()
        @fire('mfmarker:tool_selected')

    _pointSelected: (e) =>
        handler = new L.Edit.Marker(e.layer)

        handler.enable()
        @fire 'select:point-selected'

        # Disable the previous selection
        if @current_tool and @current_tool?.disable?
            @current_tool.disable()

        return handler
